"use strict";
/*
 ## External Dependencies ##
 - jQuery ($)
 */

var Prompt = require("app/shared/components/Prompt/prompt");
var BooleanInput = require("app/shared/components/BooleanInput/boolean-input");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");
var cx = require("classnames");
var _ = require("underscore");

var PromptList = React.createClass({
  propTypes: {
    checkboxItems: React.PropTypes.array.isRequired,
    onConfirm: React.PropTypes.func,
    selectionType: React.PropTypes.oneOf(["radioButton", "checkbox"]),
    buttonAlwaysEnabled: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      buttonAlwaysEnabled: false,
      selectionType: "checkbox"
    };
  },
  getInitialState: function() {
    return {
      checkboxItems: this.props.checkboxItems,
      enableConfirmButton: this.props.buttonAlwaysEnabled
    };
  },
  handleListClick: function(i) {
    if (this.props.selectionType == "checkbox") {
      this.checkboxOnClick(i);
    } else {
      this.radioButtonOnClick(i);
    }
  },
  checkboxOnClick: function(i) {
    var newCheckboxItems = this.state.checkboxItems;
    var itemToChange = newCheckboxItems[i];

    if (!itemToChange.disabled) {
      var newCheckedValue = !itemToChange.checked;
      newCheckboxItems[i].checked = newCheckedValue;
      this.setState({checkboxItems: newCheckboxItems});

      if (!this.props.buttonAlwaysEnabled) {
        this.enableConfirmButton();
      }
    }
  },
  radioButtonOnClick: function(i) {
    if (!this.state.checkboxItems[i].disabled) {
      var newCheckboxItems = _.map(this.state.checkboxItems, function(listItem, j) {
        listItem.checked = (i == j);
        return listItem;
      }.bind(this));
      this.setState({checkboxItems: newCheckboxItems});
    }
  },
  enableConfirmButton: function() {
    var enable = true;
    this.state.checkboxItems.forEach(function(listItem, index){
      enable = listItem.checked && enable;
    }.bind(this));
    this.setState({enableConfirmButton: enable});
  },
  renderListItem: function() {
    var key = 0;
    return this.state.checkboxItems.map(function(listItem, index){
      key += 1;
      var textClass = cx({
        "d-b c-333 lh-15 pl-25": true,
        "fst-italic c-888": listItem.disabled
      });

      return (
        <li key={key} className="ta-l mb-15 c-pointer" onClick={this.handleListClick.bind(null, index)}>
          <div className="d-b f-l">
            <BooleanInput type={this.props.selectionType} checked={listItem.checked}>
            </BooleanInput>
          </div>
          <div className={textClass}>
            {listItem.text}
            {
              listItem.tooltip ? (
                <Tooltip title={listItem.tooltip}>
                  <Button className="ml-2 p-0" type="link">
                    <Icon custom icon="help-circle" />
                  </Button>
                </Tooltip>
              ) : null
            }
          </div>
        </li>
      );
    }.bind(this));
  },
  renderCheckboxList: function() {
    return (
      <ul className="mt-30 prompt-text">
        {this.renderListItem()}
      </ul>
    );
  },
  handleConfirm: function() {
    if (typeof(this.props.onConfirm) == "function") {
      var selectedItems = [];
      _.each(this.state.checkboxItems, function(listItem) {
        if (listItem.checked) {
          selectedItems.push(listItem);
        }
      }.bind(this));
      this.props.onConfirm(selectedItems);
    }
  },
  render: function(){
    if (!this.props.isOpen) {
      return (<div></div>);
    }
    return (
      <Prompt {...this.props} disabledConfirmButton={!this.state.enableConfirmButton}
        onConfirm={this.handleConfirm}
        tooltipTitle="Antes, leia atentamente e marque todos os itens acima."
        showTooltip={!this.state.enableConfirmButton}>
        {this.renderCheckboxList()}
      </Prompt>
    );
  }
});


module.exports = PromptList;



// WEBPACK FOOTER //
// ./app/shared/components/Prompt/prompt-list.jsx